<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>赠送优惠券</span>
            <div>
              <el-button type="primary" size="small" @click="_closebuyGoldSend">
                <i class="el-icon-close"></i> 返回
              </el-button>
            </div>
          </div>
          <div class="card-body">
            <el-form label-position="right" label-width="120px">
              <el-form-item label="优惠券">
                <el-input v-model="buyGoldSendInfo.couponName" disabled placeholder="优惠券"></el-input>
              </el-form-item>
              <el-form-item label="库存">
                <el-input v-model="buyGoldSendInfo.stock" disabled placeholder="库存"></el-input>
              </el-form-item>
              <el-form-item label="赠送数量">
                <el-input 
                  v-model="buyGoldSendInfo.goldCostMoney" 
                  type="number" 
                  @change="_changeGoldCount"
                  placeholder="必填，请填写购买赠送数量"></el-input>
              </el-form-item>
              <el-form-item label="会员">
                <el-col :span="18">
                  <el-input v-model="buyGoldSendInfo.vipName" disabled placeholder="会员"></el-input>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" @click="_openAddChooseShopVipUserModel">
                    <i class="el-icon-check"></i>&nbsp;选择
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div style="text-align: right; margin-top: 20px;">
          <el-button type="primary" @click="_tobuyGoldSend">
            <i class="el-icon-check"></i>&nbsp;赠送
          </el-button>
        </div>
      </el-col>
    </el-row>

    <choose-shop-vip-user ref="chooseShopVipUser"></choose-shop-vip-user>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listCouponShopPool, sendGoldCount } from '@/api/goods/buyGoldSendApi'
import ChooseShopVipUser from '@/components/goods/chooseShopVipUser/chooseShopVipUser.vue'

export default {
  name: 'BuyGoldSend',
  components: {
    ChooseShopVipUser
  },
  data() {
    return {
      buyGoldSendInfo: {
        spId: '',
        actualPrice: '0',
        couponName: '0',
        stock: '0',
        goldCostMoney: '0',
        vipId: '',
        vipName: '',
        shopId: '',
        showRefresh: false
      }
    }
  },
  created() {
    this.buyGoldSendInfo.shopId = getShopId()
    this.buyGoldSendInfo.spId = this.$route.query.spId
    this._listProducts()
  },
  methods: {
    _listProducts() {
      const params = {
        page: 1,
        spId: this.buyGoldSendInfo.spId,
        row: 1
      }
      listCouponShopPool(params).then(res => {
        if (res.code === 0) {
          Object.assign(this.buyGoldSendInfo, res.data[0])
        }
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    _closebuyGoldSend() {
      this.$router.go(-1)
    },
    _openAddChooseShopVipUserModel() {
      this.$refs.chooseShopVipUser.open()
    },
    _changeGoldCount() {
      if (this.buyGoldSendInfo.stock - this.buyGoldSendInfo.goldCostMoney < 0) {
        this.$message.warning("库存不足，请先购买优惠卷！")
      }
    },
    _tobuyGoldSend() {
      if (this.buyGoldSendInfo.stock - this.buyGoldSendInfo.goldCostMoney < 0) {
        this.$message.warning("库存不足，请先购买优惠卷！")
        return
      }
      if (!this.buyGoldSendInfo.vipId) {
        this.$message.warning("请选择会员信息")
        return
      }

      sendGoldCount(this.buyGoldSendInfo).then(res => {
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._closebuyGoldSend()
        }
      }).catch(error => {
        console.error('请求失败:', error)
        this.$message.error(error)
      })
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.card-body {
  padding: 20px;
}
.el-input {
  width: 100%;
}
</style>